import React from 'react'

function OrderPrint(props) {
const weburl='';
const currency='';
  const checkfreshinvoice='1';
  const decideCustomer=localStorage.getItem('creditcash')?localStorage.getItem('creditcash'):'1';
  
  // Configuration for optional fields
  const showPackDetails = false;
  const showWeight = false;

  const showUrduText = false;
  // Thermal printer width (typically 80mm/3.15 inches)
  const thermalPrinterWidth = '80mm';
  
  const thermalStyles = {
    container: {
      width: thermalPrinterWidth,
      margin: '0 auto',
      padding: '0',
      fontSize: '8px',
      fontFamily: 'Courier New, monospace', // Monospaced font for thermal printers
      boxSizing: 'border-box',
      overflow: 'hidden',
      lineHeight: '1.2',
      whiteSpace: 'nowrap',
    },
    header: {
      textAlign: 'center',
      marginBottom: '2px',
      padding: '0',
    },
    companyName: {
      fontSize: '14px',
      fontWeight: 'bold',
      margin: '0',
      padding: '0',
      textTransform: 'uppercase',
    },
    companyInfo: {
      fontSize: '14px',
      margin: '0',
      padding: '0',
      lineHeight: '1',
    },
    divider: {
      borderTop: '1px dashed #000',
      margin: '3px 0',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      fontSize: '14px',
      margin: '0',
    },
    tableRow: {
      borderBottom: '1px dotted #ccc',
    },
    amountRow: {
      display: 'flex',
      justifyContent: 'space-between',
      margin: '1px 0',
      fontSize: '8px',
    },
    totalRow: {
      display: 'flex',
      justifyContent: 'space-between',
      margin: '2px 0',
      fontSize: '18px',
      fontWeight: 'bold',
      borderTop: '1px solid #000',
      paddingTop: '2px',
    },
    center: {
      textAlign: 'center',
      width: '100%',
    },
    barcodeArea: {
      height: '30px',
      margin: '5px 0',
      textAlign: 'center',
    }
  };

  const posStyles = {
    container: {
      width: '180mm',
     height:'200mm',
      margin: '0 auto',
      padding: '5px',
      fontSize: '20px',
      fontFamily: 'Arial, sans-serif',
      boxSizing: 'border-box',
     
      
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '4px',
      padding: '0',
    },
    logo: {
      width: '50px',
      height: '50px',
      objectFit: 'contain',
    },
    companyInfo: {
      textAlign: 'center',
      flexGrow: 1,
      padding: '0 5px',
    },
    customerInfo: {
      display: 'flex',
      justifyContent: 'space-between',
      margin: '4px 0',
      fontSize: '99px',
    },
    infoBox: {
      flex: 1,
      border: '1px solid #000',
      borderRadius: '3px',
      padding: '3px',
      margin: '0 2px',
      fontSize: '14px',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      fontSize: '12px',
      fontWeight: 'bold',
      margin: '2px 0',
    },
    th: {
      border: '1px solid #000',
      padding: '2px',
      textAlign: 'center',
      fontWeight: 'bold',
      fontSize: '14px',
    },
    td: {
      border: '1px solid #000',
      padding: '0px',
      textAlign: 'center',
      fontSize:'12px'
    },
    tdLeft: {
      border: '1px solid #000',
      padding: '2px',
      textAlign: 'left',
    },
    footer: {
      marginTop: '4px',
      padding: '0',
       fontWeight: 'bold',
    },
    amountRow: {
      display: 'flex',
      justifyContent: 'space-between',
      margin: '1px 0',
      fontSize:'14px'
    
      
    },
    totalRow: {
      display: 'flex',
      justifyContent: 'space-between',
      margin: '2px 0',
      fontSize: '16px',
      fontWeight: 'bold',
      borderTop: '1px solid #000',
      paddingTop: '2px',

    },
    urduText: {
      fontFamily: 'Noto Nastaliq Urdu, cursive',
      direction: 'rtl',
      textAlign: 'center',
      fontSize: '12px',
      display: showUrduText ? 'block' : 'none',

    }
  };
  
  const total = props.data.letter.reduce((acc, item) => {
    const value = parseFloat(item.qty*item.unitsaleprice);
    return isNaN(value) ? acc : acc + value;
  }, 0);
  
  const subtotaldiscount = props.data.letter.reduce((acc, item) => {
    const value = parseFloat(item.subtotaldiscount);
    return isNaN(value) ? acc : acc + value;
  }, 0);
  
  const totalqty = props.data.letter.reduce((acc, item) => {
    const value = parseFloat(item.qty);
    return isNaN(value) ? acc : acc + value;
  }, 0);
  
  const totalpack = props.data.letter.reduce((acc, item) => {
    const value = Math.floor(item.qty/item.pack_size);
    return isNaN(value) ? acc : acc + value;
  }, 0);
  
  const totalweight = props.data.letter.reduce((acc, item) => {
    const value = parseFloat(item.qty*item.weight);
    return isNaN(value) ? acc : acc + value;
  }, 0);

  const totalcost = props.data.letter.reduce((acc, item) => {
    const value = (((item.qty * item.unitsaleprice) - item.subtotaldiscount)-(item.qty*item.costprice));
    return isNaN(value) ? acc : acc + value;
  }, 0);
  /*
  const totalrate = props.data.letter.reduce((acc, item) => {
    const value = parseFloat(item.unitsaleprice);
    return isNaN(value) ? acc : acc + value;
  }, 0);
  */
  const pos = localStorage.getItem('pos') || '0';
  
  if(pos !== '0') {
    // Thermal Printer Invoice (POS mode)
    return (
      <div id='printablearea' style={thermalStyles.container}>
        {/* Header */}
        <div style={thermalStyles.header}>
          <div style={thermalStyles.companyName}>
            {props.data.detail.slogan_heading}
          </div>
          <div style={thermalStyles.companyInfo}>
            {props.data.detail.slogan_subheading}
          </div>
          <div style={thermalStyles.companyInfo}>
            Ph: {props.data.detail.phone} | Tax: {props.data.detail.taxinput}
          </div>
        </div>
        
        <div style={thermalStyles.divider}></div>
        
        {/* Invoice Info */}
        <div style={thermalStyles.center}>
          <div style={{fontSize: '8px', margin: '1px 0'}}>
            <strong>{props.data.mesg === '200' ? 'RETURN INVOICE' : 'SALES INVOICE'}</strong>
          </div>
          <div style={{fontSize: '7px', margin: '1px 0'}}>
            INV#: {props.data.invoiceno}
          </div>
          <div style={{fontSize: '7px', margin: '1px 0'}}>
            Date: {props.data.manualdate} {props.data.printingtime}
          </div>
          <div style={{fontSize: '7px', margin: '1px 0'}}>
            Customer: {props.data.customer.name || 'Walk-in Customer'}
          </div>
        </div>
        
        <div style={thermalStyles.divider}></div>
        
        {/* Items Table - Simplified for thermal printer */}
        <table style={thermalStyles.table}>
          <thead>
            <tr style={thermalStyles.tableRow}>
              <th style={{textAlign: 'left', padding: '1px', width: '10%'}}>#</th>
              <th style={{textAlign: 'left', padding: '1px', width: '40%'}}>ITEM</th>
              <th style={{textAlign: 'right', padding: '1px', width: '15%'}}>QTY</th>
              <th style={{textAlign: 'right', padding: '1px', width: '15%'}}>RATE</th>
              <th style={{textAlign: 'right', padding: '1px', width: '20%'}}>TOTAL</th>
            </tr>
          </thead>
          <tbody>
            {props.data.letter && props.data.letter.map((item, index) => (
              <tr key={index} style={thermalStyles.tableRow}>
                <td style={{textAlign: 'left', padding: '1px'}}>{index + 1}</td>
                <td style={{textAlign: 'left', padding: '1px', fontSize: '7px'}}>
                  {item.name}
                </td>
                <td style={{textAlign: 'right', padding: '1px'}}>{item.qty}</td>
                <td style={{textAlign: 'right', padding: '1px'}}>
                  {props.data.isGift === 'No' ? parseFloat(item.unitsaleprice).toFixed(2) : '0.00'}
                </td>
                <td style={{textAlign: 'right', padding: '1px'}}>
                  {props.data.isGift === 'No' ? (item.qty * item.unitsaleprice).toFixed(2) : '0.00'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        
        <div style={thermalStyles.divider}></div>
        
        {/* Totals Section */}
        {props.data.isGift === 'No' ? (
          <div style={{padding: '0 2px'}}>
            {/* Subtotal */}
            <div style={thermalStyles.amountRow}>
              <span>Subtotal:</span>
              <span>{currency} {parseFloat(total).toFixed(2)}</span>
            </div>
            
            {/* Item Discount - Show only if exists */}
            {parseFloat(subtotaldiscount) > 0 && (
              <div style={thermalStyles.amountRow}>
                <span>Item Discount:</span>
                <span>- {currency} {parseFloat(subtotaldiscount).toFixed(2)}</span>
              </div>
            )}
            
            {/* Invoice Discount - Show only if exists */}
            {parseFloat(props.data.discount) > 0 && (
              <div style={thermalStyles.amountRow}>
                <span>Invoice Discount:</span>
                <span>- {currency} {parseFloat(props.data.discount).toFixed(2)}</span>
              </div>
            )}
            
            {/* Shipping - Show only if exists */}
            {parseFloat(props.data.shipping) > 0 && (
              <div style={thermalStyles.amountRow}>
                <span>Shipping:</span>
                <span>+ {currency} {parseFloat(props.data.shipping).toFixed(2)}</span>
              </div>
            )}
            
            {/* Tax - Show only if exists */}
            {parseFloat(props.data.salestax) > 0 && (
              <div style={thermalStyles.amountRow}>
                <span>{props.data.detail.taxname}:</span>
                <span>+ {currency} {parseFloat(props.data.salestax).toFixed(2)}</span>
              </div>
            )}
            
            {/* Grand Total */}
            <div style={thermalStyles.totalRow}>
              <span>GRAND TOTAL:</span>
              <span>
                {currency} {parseFloat(
                  parseFloat(props.data.remainingbill || props.data.grandtotal) + 
                  parseFloat(props.data.salestax || 0) + 
                  parseFloat(props.data.shipping || 0)
                ).toFixed(2)}
              </span>
            </div>
            
            {/* Payment Section */}
            {checkfreshinvoice === props.data.indicator && decideCustomer === '1' && (
              <>
                <div style={thermalStyles.amountRow}>
                  <span>Paid:</span>
                  <span>{currency} {parseFloat(props.data.entercash || 0).toFixed(2)}</span>
                </div>
                <div style={thermalStyles.amountRow}>
                  <span>Change:</span>
                  <span>
                    {currency} {parseFloat(
                      parseFloat(props.data.entercash || 0) - 
                      parseFloat(props.data.payment || 0) - 
                      parseFloat(props.data.recovery || 0)
                    ).toFixed(2)}
                  </span>
                </div>
              </>
            )}
            
            {/* Previous Balance - Show only if exists */}
            {parseFloat(props.data.pbalance) > 0 && (
              <div style={{...thermalStyles.amountRow, fontWeight: 'bold'}}>
                <span>Prev Balance:</span>
                <span>{currency} {parseFloat(props.data.pbalance).toFixed(2)}</span>
              </div>
            )}
            
            {/* Balance Due - For credit sales */}
            {checkfreshinvoice !== props.data.indicator && decideCustomer !== '1' && (
              <div style={{...thermalStyles.totalRow, borderTop: '2px solid #000'}}>
                <span>BALANCE DUE:</span>
                <span>
                  {currency} {parseFloat(
                    parseFloat(props.data.remainingbill || props.data.grandtotal) + 
                    parseFloat(props.data.salestax || 0) + 
                    parseFloat(props.data.shipping || 0) + 
                    parseFloat(props.data.pbalance || 0) - 
                    (parseFloat(props.data.payment || 0) + parseFloat(props.data.recovery || 0))
                  ).toFixed(2)}
                </span>
              </div>
            )}
            
            <div style={thermalStyles.divider}></div>
            
            {/* Footer */}
            <div style={thermalStyles.center}>
              <div style={{fontSize: '7px', margin: '2px 0'}}>
                Thank you for your purchase!
              </div>
              <div style={{fontSize: '6px', margin: '1px 0'}}>
                {props.data.detail.address || ''}
              </div>
            </div>
            
            {/* Barcode area for thermal printer */}
            <div style={thermalStyles.barcodeArea}>
              <div style={{fontSize: '6px'}}>
                {/* Optional: Add barcode here */}
                * {props.data.invoiceno} *
              </div>
            </div>
          </div>
        ) : (
          /* Gift Invoice */
          <div style={thermalStyles.center}>
            <div style={{fontSize: '9px', margin: '5px 0'}}>
              🎁 GIFT INVOICE 🎁
            </div>
            <div style={{fontSize: '7px', margin: '2px 0'}}>
              No Payment Required
            </div>
            <div style={{fontSize: '6px', margin: '5px 0'}}>
              Thank you for your trust!
            </div>
          </div>
        )}
      </div>
    );
  } else {
    // Regular Invoice (Detailed mode)
    return (
      <div id='printablearea' style={posStyles.container}>
        <div style={posStyles.header}>
          <div style={{flex: 1}}>
            <h3 style={{margin: '2px 0', fontSize: '18px', textAlign: 'center'}}>
              {props.data.detail.slogan_heading}
            </h3>
            <p style={{margin: '1px 0', fontSize: '15px', textAlign: 'center'}}>
              {props.data.detail.slogan_subheading}
            </p>
            <p style={{margin: '1px 0', fontSize: '12px', textAlign: 'center'}}>
              Ph: {props.data.detail.phone} | Tax: {props.data.detail.taxinput}
            </p>
          </div>
          <img 
            style={{...posStyles.logo, width: '40px', height: '40px'}} 
            src={`${weburl}${props.data.detail.logo}`} 
            alt="Logo"
          />
        </div>
        
        <div style={{textAlign: 'center', margin: '2px 0', fontSize: '9px'}}>
          <p style={{margin: '1px 0'}}>
            <strong>Invoice:</strong> {props.data.invoiceno} | 
            <strong> Date:</strong> {props.data.manualdate}
          </p>
        </div>
        
        <div style={posStyles.customerInfo}>
          <div style={posStyles.infoBox}>
            <div><strong>Customer:</strong> {props.data.customer.name}</div>
            <div><strong>Contact:</strong> {props.data.customer.phone}</div>
            <div style={{display: props.data.customeraddress ? 'block' : 'none'}}>
              <strong>Address:</strong> {props.data.customeraddress}
            </div>
          </div>
          <div style={posStyles.infoBox}>
            <div><strong>Salesman:</strong> {props.data.salesman.name}</div>
            <div><strong>Phone:</strong> {props.data.salesman.phone}</div>
          </div>
        </div>
        
        {/* Optional Urdu Text Section */}
        <div style={posStyles.urduText}>
          کیلکولیٹر خریدنے سے پہلے اچھی طرح چیک کر لیں، یہ ناقابل واپسی ہو گا
        </div>
        
        <table style={posStyles.table}>
          <thead>
            <tr>
              <th style={{...posStyles.th, width: '5%'}}>#</th>
              <th style={{...posStyles.th, width: showPackDetails || showWeight ? '25%' : '35%'}}>Item</th>
              
              {/* Pack Details Column (Optional) */}
              <th style={{...posStyles.th, width: '8%', display: showPackDetails ? 'table-cell' : 'none'}}>
                Packs
              </th>
              
              {/* Pieces Column (Optional) */}
              <th style={{...posStyles.th, width: '8%', display: showPackDetails ? 'table-cell' : 'none'}}>
                Pcs
              </th>
              
              <th style={{...posStyles.th, width: '8%'}}>Qty</th>
              <th style={{...posStyles.th, width: '8%'}}>Unit</th>
              
              {/* Weight Column (Optional) */}
              <th style={{...posStyles.th, width: '8%', display: showWeight ? 'table-cell' : 'none'}}>
                Weight
              </th>
              
              <th style={{...posStyles.th, width: '12%'}}>Rate</th>
              <th style={{...posStyles.th, width: '20%'}}>Disc</th>
              <th style={{...posStyles.th, width: '18%'}}>Total</th>
            
            {props.data.isGift === 'Yes' ? (

              <th style={{...posStyles.th, width: '14%'}}>Profit</th>

            ):('')}
            </tr>
          </thead>
          <tbody>
            {props.data.letter && props.data.letter.map((item, index) => (
              <tr key={index}>
                <td style={posStyles.td}>{index + 1}</td>
                <td style={{...posStyles.td, textAlign: 'left'}}>
                  {item.name}
                </td>
                
                {/* Pack Details Cells (Optional) */}
                <td style={{...posStyles.td, display: showPackDetails ? 'table-cell' : 'none'}}>
                  {Math.floor(item.qty/item.pack_size)}
                </td>
                <td style={{...posStyles.td, display: showPackDetails ? 'table-cell' : 'none'}}>
                  {(item.qty % item.pack_size)}
                </td>
                
                <td style={posStyles.td}>{item.qty}</td>
                <td style={posStyles.td}>{item.unit}</td>
                
                {/* Weight Cell (Optional) */}
                <td style={{...posStyles.td, display: showWeight ? 'table-cell' : 'none'}}>
                  {(item.qty * item.weight).toFixed(2)}
                </td>
                
                <td style={posStyles.td}>{item.unitsaleprice}</td>
                <td style={posStyles.td}>
                  {item.discountpercent}% ({parseFloat(item.subtotaldiscount).toFixed(2)})
                </td>
                <td style={posStyles.td}>
                  {parseFloat((item.qty * item.unitsaleprice) ).toFixed(2)}
                </td>

                  {props.data.isGift === 'Yes' ? (

              <td style={{...posStyles.td, width: '14%'}}>
                  {parseFloat(((item.qty * item.unitsaleprice) - item.subtotaldiscount)-(item.qty*item.costprice)).toFixed(2)}



              </td>

            ):('')}
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="2" style={{...posStyles.td, textAlign: 'left'}}>
                <strong>Total Items: {props.data.letter.length}</strong>
              </td>
              
              {/* Pack Total Cells (Optional) */}
              <td style={{...posStyles.td, display: showPackDetails ? 'table-cell' : 'none', fontWeight: 'bold'}}>
                {totalpack.toFixed(2)}
              </td>
              <td style={{...posStyles.td, display: showPackDetails ? 'table-cell' : 'none'}}></td>
              
              <td style={{...posStyles.td, fontWeight: 'bold'}}>{totalqty.toFixed(2)}</td>
              <td style={posStyles.td}></td>
              
              {/* Weight Total Cell (Optional) */}
              <td style={{...posStyles.td, display: showWeight ? 'table-cell' : 'none', fontWeight: 'bold'}}>
                {totalweight.toFixed(2)}
              </td>
              
              <td style={posStyles.td}></td>
              <td style={{...posStyles.td, fontWeight: 'bold'}}>{subtotaldiscount.toFixed(2)}</td>
              <td style={{...posStyles.td, fontWeight: 'bold',display:'none'}}>
                {(total - subtotaldiscount).toFixed(2)}
              </td>
               <td style={{...posStyles.td, fontWeight: 'bold'}}>
                {(total).toFixed(2)}
              </td>
                {props.data.isGift === 'Yes' ? (

              <td style={{...posStyles.td, fontWeight: 'bold'}}>
                {(totalcost).toFixed(2)}
              </td>):('')}
            </tr>
          </tfoot>
        </table>
        
        <div style={posStyles.footer}>
          <div style={posStyles.amountRow}>
            <span>Sub Total:</span>
            <span>{currency} {parseFloat(props.data.grandtotal).toFixed(2)}</span>
          </div>
          
          {/* Invoice Discount - Show only if exists */}
          {parseFloat(props.data.discount) > 0 && (
            <div style={posStyles.amountRow}>
              <span>Invoice Discount:</span>
              <span>- {currency} {parseFloat(props.data.discount).toFixed(2)}</span>
            </div>
          )}
          
          {/* Shipping - Show only if exists */}
          {parseFloat(props.data.shipping) > 0 && (
            <div style={posStyles.amountRow}>
              <span>Shipping:</span>
              <span>+ {currency} {parseFloat(props.data.shipping).toFixed(2)}</span>
            </div>
          )}
          
          {/* Tax - Show only if exists */}
          {parseFloat(props.data.salestax) > 0 && (
            <div style={posStyles.amountRow}>
              <span>Tax ({props.data.detail.taxname}):</span>
              <span>+ {currency} {parseFloat(props.data.salestax).toFixed(2)}</span>
            </div>
          )}
          
          <div style={posStyles.totalRow}>
            <span>NET TOTAL:</span>
            <span>
              {currency} {parseFloat(
                parseFloat(props.data.remainingbill || props.data.grandtotal) + 
                parseFloat(props.data.salestax || 0) + 
                parseFloat(props.data.shipping || 0)
              ).toFixed(2)}
            </span>
          </div>
          
          {/* Previous Balance - Show only if exists */}
          {parseFloat(props.data.pbalance) > 0 && (
            <div style={posStyles.amountRow}>
              <span>Previous Balance:</span>
              <span>+ {currency} {parseFloat(props.data.pbalance).toFixed(2)}</span>
            </div>
          )}
          
          <div style={posStyles.amountRow}>
            <span>Payment Received:</span>
            <span>- {currency} {(parseFloat(props.data.payment) + parseFloat(props.data.recovery)).toFixed(2)}</span>
          </div>
          
          <div style={{...posStyles.totalRow, borderTop: '2px solid #000'}}>
            <span>BALANCE DUE:</span>
            <span>
              {currency} {parseFloat(
                parseFloat(props.data.remainingbill || props.data.grandtotal) + 
                parseFloat(props.data.salestax || 0) + 
                parseFloat(props.data.shipping || 0) + 
                parseFloat(props.data.pbalance || 0) - 
                (parseFloat(props.data.payment || 0) + parseFloat(props.data.recovery || 0))
              ).toFixed(2)}
            </span>
          </div>
          
          <div style={{textAlign: 'center', marginTop: '4px', fontSize: '8px'}}>
            <p>Thank you for your business!</p>
            <p>Invoice Date: {props.data.manualdate} | Printed: {props.data.printingtime}</p>
          </div>
        </div>
      </div>
    );
  }
}

export default OrderPrint;